import FilePaymentDet from "./FilePaymentDet";
import FilePaymentFIl from "./FilePaymentFIl";
import { useSelector } from "react-redux";
import StlapFooter from "../../CustomComponents/StlapFooter";
import { Box } from "@mui/material";

const FilePaymentInt = () => {
  const showDetailScreen = useSelector(
    (state) => state.filePaymentModify.HideComponents.showGridComponent
  );
  return (
    <>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <FilePaymentFIl />
        {showDetailScreen && <FilePaymentDet />}
      </Box>
      <StlapFooter />
    </>
  );
};
export default FilePaymentInt;
